/* eslint-disable no-param-reassign */
import priceFormatter from '../../../util/priceFormatter';
import getCarts from '../../integration/cart.api';
import { getTokenFromCookies, getCookie } from '../../hooks/useCookie';

// const localStore = useLocalStorage();

export const syncAPIandStrapiData = (data, tvTariff) => {
  const tempData = data.map(item => {
    if (item.ctaType === 'add') {
      item.info.code = tvTariff?.code;
      item.info.offerCode = tvTariff?.offerCode;
      item.info.title = tvTariff?.preTitle;
      item.info.subTitle = tvTariff?.title;
      item.info.price = `€${tvTariff?.price}`;
      item.info.afterPrice = tvTariff?.afterPriceAmount;
      item.info.contractPeriod = tvTariff?.discountDuration || 0;
    }
    return item;
  });

  return tempData;
};
export const formatCrossSellStrapiData = data => {
  const result = data.map(item => {
    const obj = {
      attributes: item.FeatAndImg.featuresList,
      img: item.FeatAndImg.cardImage?.data?.attributes?.url,
      altText: item.FeatAndImg.cardImage?.data?.attributes?.alternativeText || '',
      info: {
        title: item.CSPreTariff?.tariffDetails?.displayName,
        subTitle: item.CSPreTariff?.tariffDetails.subDisplayName,
        price: priceFormatter(item.CSPreTariff?.tariffDetails.price),
        afterPrice: priceFormatter(
          item.CSPreTariff?.tariffDetails?.afterPrice || item.CSPreTariff?.tariffDetails.price
        ),
        contractPeriod: item.CSPreTariff?.tariffDetails.contractPeriod || 0,
      },
      ctaType: item.cardType.cardType === 'TV' ? 'add' : 'nav',
      featureFontColor: item.fontColor,
    };
    return obj;
  });
  return result;
};

const getSelectedTvOfferFromCart = async graphql => {
  // get the selected offer value from prospect.
  const { getCart: cartData } = await getCarts({
    graphql,
    variables: {
      reference: getCookie('reference'),
      cartType: getCookie('cart_Type'),
      token: getTokenFromCookies(),
    },
  });
  return {
    cartData,
    selectedOffer: cartData?.offers?.filter(offer => offer?.baseOffer?.serviceGroup === 'TV') || [],
  };
};
export const CSonLoad = async ({ graphql, dispatch }) => {
  let result = {};
  try {
    // if prospect is already present
    if (getCookie('reference')) {
      // getting selected mobile offers from cart
      const { selectedOffer, cartData } = await getSelectedTvOfferFromCart(graphql);

      dispatch({ type: 'SET_CART', payload: cartData });
      result = {
        ...result,
        selectedOffer,
        cartData,
      };
    }
  } catch (error) {
    console.error('something went wrong on load of /shop/broadband', error);
    return {
      cartData: {},
      selectedOffer: [],
    };
  }
  return result;
};
